import type { Id } from 'convex/_generated/dataModel';
import type { Garden } from '@modules/garden-planner/business_logic';

export function createHandleSetAllCellsAvailability(
  selectedGarden: Garden | null | undefined,
  setAllCellsAvailability: (args: {
    gardenId: Id<'gardens'>;
    available: boolean;
  }) => Promise<unknown>
) {
  return async (available: boolean) => {
    if (!selectedGarden) return;
    await setAllCellsAvailability({ gardenId: selectedGarden._id, available });
  };
}
